import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import clsx from 'clsx';
import { Stack } from '@mui/system';
import './TP_Dropdown.scss';

function TP_Dropdown(props) {
	const { selectDropDown, clearID } = props;

	const selectInputRef = useRef();

	const onClear = () => {
		console.log('selectInputRef', selectInputRef);
		selectInputRef.current.clearValue();
	};
	let customStyles = {
		option: (styles) => {
			return {
				...styles,
				backgroundColor: 'var(--lightBlack)',
				color: '#fff',
				borderColor: 'var(--lightBlack)',
			};
		},
		valueContainer: (styles) => {
			return { ...styles, backgroundColor: 'var(--lightBlack)', color: '#fff' };
		},
		control: (styles) => {
			return {
				...styles,
				backgroundColor: 'var(--lightBlack)',
				borderColor: 'var(--lightBlack)',
				overflowY: 'auto',
				borderRadius: '20px',
				width: '60%',
				overflow: 'hidden',
			};
		},
		singleValue: (styles) => {
			return {
				...styles,
				color: '#fff',
				fontSize: '12px',
			};
		},
		dropdownIndicator: (styles) => {
			return {
				...styles,
				backgroundColor: 'var(--lightBlack)',
				borderColor: '#313131',
			};
		},
		multiValue: (styles) => {
			return {
				...styles,
				backgroundColor: '#e6e6e6',
				borderColor: '#313131',
				color: '#000',
				fontSize: '12px',
				fontFamily: 'Eurostile Extended',
				fontWeight: '100',
			};
		},
		multiValueRemove: (styles) => {
			return { ...styles, backgroundColor: '#e6e6e6', color: '#000' };
		},
		multiValueLabel: (styles) => {
			return {
				...styles,
				color: '#000',
				fontFamily: 'Eurostile',
				fontSize: '13',
				height: '25',
			};
		},
		indicatorsContainer: (styles) => {
			return {
				...styles,
				backgroundColor: '#141623',
				borderColor: '#313131',
				position: ' absolute',
				right: '0px',
				fontSize: '12px',
				fontFamily: 'Eurostile Extended',
			};
		},
		indicatorSeparator: (styles) => {
			return { ...styles, display: 'none' };
		},
		clearIndicator: (styles) => {
			return { ...styles, backgroundColor: '#0d0d17', borderColor: '#313131' };
		},
		placeholder: (styles) => {
			return {
				...styles,
				color: '#636973',
				fontSize: '12px',
				fontFamily: 'Eurostile Extended',
			};
		},
		menu: (styles) => {
			return {
				...styles,
				margin: 0,
				background: '#141623',
				fontSize: '12px',
				fontFamily: 'Eurostile Extended',
			};
		},
		input: (styles) => {
			return {
				...styles,
				color: '#ffffff',
				fontFamily: 'Eurostile',
				fontSize: '13',
				height: '25',
			};
		},
	};

	const [text, setText] = useState({});

	const handleChange = (event) => {
		setText(event);
	};

	useEffect(() => {
		selectDropDown(text);
	}, [text]);

	return (
		<div id="Tpdropdown">
			<Select
				className="react-select-container"
				classNamePrefix="react-select"
				ref={selectInputRef}
				isClearable
				options={props.options}
				placeholder={props.placeholder}
				value={props.value}
				closeMenuOnSelect={true}
				hideSelectedOptions={false}
				components={props.components}
				styles={customStyles}
				onChange={handleChange}
				allowSelectAll={true}
				isSearchable={true}
				isMulti={props.isMulti === true ? true : false}
			/>
			<Stack className="cleartext" onClick={onClear} id={clearID}>
				Clear
			</Stack>
			{/* </Stack> */}
		</div>
	);
}

export default TP_Dropdown;
